var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 75,
    viewBox: "0 0 90 75",
    fill: "#94D0D6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H30L45 15H80C82.6522 15 85.1957 16.0536 87.0711 17.9289C88.9464 19.8043 90 22.3478 90 25V65C90 67.6522 88.9464 70.1957 87.0711 72.0711C85.1957 73.9464 82.6522 75 80 75H10C7.34784 75 4.8043 73.9464 2.92893 72.0711C1.05357 70.1957 0 67.6522 0 65V10C0 7.34784 1.05357 4.8043 2.92893 2.92893C4.8043 1.05357 7.34784 0 10 0Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.6572631c.svg";
export { ForwardRef as ReactComponent };